import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem('jilong_admin_token') || '');
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  const authAxios = useCallback((tk = token) => {
    return axios.create({
      baseURL: API,
      headers: tk ? { Authorization: `Bearer ${tk}` } : {},
    });
  }, [token]);

  const login = async (username, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { username, password });
    localStorage.setItem('jilong_admin_token', data.token);
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem('jilong_admin_token');
    setToken('');
    setUser(null);
  };

  useEffect(() => {
    if (!token) { setUser(null); setChecking(false); return; }
    axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem('jilong_admin_token'); setToken(''); setUser(null); })
      .finally(() => setChecking(false));
  }, [token]);

  return (
    <AuthContext.Provider value={{ token, user, checking, login, logout, authAxios }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
